/***********************************
  Historical Stock Lookup Module
************************************/

Quad.HistoricalStockLookup = ( function() {


    // PRIVATE VARS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    var path = window.location.href.split( '/' );
    path     = path[0]+'//'+path[ 2 ];
  
    // PRIVATE METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    function _init(){

      $('#historical-stock-form').submit(function(e){
        e.preventDefault();

        $('#historical-stock-lookup .no-results').hide();
        $('#historical-stock-lookup .loading-results').css('display','block');

        var day     = $('#historical-stock-form select[name="day"]').val(),
            month   = $('#historical-stock-form select[name="month"]').val(),
            year    = $('#historical-stock-form select[name="year"]').val(),
            dateUrl = path+'/wp-json/investor-relations/v1/quotes/historical/'+year+'/'+month+'/'+day;

        $.get( dateUrl,function(data){

          console.log( data );

          $('#historical-stock-lookup .loading-results').hide();
          
          if( data.quotes.length ){
          
            window.innerWidth > 767 ? $('#historical-stock-results').css('display','flex') : $('#historical-stock-results').css('display','block');

            var close   = '$'+data.quotes[0].close.toFixed(2),
                open    = '$'+data.quotes[0].open.toFixed(2),
                volume  = data.quotes[0].volume.toLocaleString('en'),
                highLow = '$'+data.quotes[0].high.toFixed(2)+'/$'+data.quotes[0].low.toFixed(2);

            $('.historical-closing-price').text(close);
            $('.historical-opening-price').text(open);
            $('.historical-volume').text(volume);
            $('.historical-high-low').text(highLow);

          } else {

            $('#historical-stock-results').hide();
            $('#historical-stock-lookup .no-results').css('display','block');

          }

        });

      });
  
    }
  
    // PUBLIC METHODS
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~
    return {
  
      init: _init
  
    };
  
  })();